export default "__VITE_ASSET__Cbe1HjeK__"